import styled from "styled-components";

/**
 * 모달 푸터 공용 버튼 (회원 관리·관리자 권한/추가 모달 등).
 *
 * 기존에 회원 도메인 모달들이 각자 동일하게 선언하던 ModalButton을 통일한 것.
 * 기본은 흰 배경/검은 글씨의 보조 버튼이며, 주(파랑) 버튼은 사용처에서
 * style로 배경·글씨색을 덮어쓴다. (마진도 화면마다 달라 포함하지 않는다.)
 */
export const ModalButton = styled.button`
  border-radius: 5px;
  background-color: #fff;
  padding: 10px 60px;
  font-family: "Noto Sans KR";
  font-size: 16px;
  font-weight: 500;
  border: 1px solid var(--admin-gray-stroke, #e8e8e8);
  cursor: pointer;
`;
